import {getUser} from './auth-client'
//import {readForUser} from './list-items-client'

async function bootstrapAppData() {
  const data = await getUser()
  const user = data
  return { user }
}

export {bootstrapAppData}